/**
 * @desc 函数防抖---“立即执行” 和 “非立即执行” 的组合版本
 * @param func 需要执行的函数
 * @param wait 延迟执行时间（毫秒）
 * @param immediate---true 立即执行，false 非立即执行
 **/
export function debounce (func, wait = 500, immediate = true) {
  let timer;
  return function () {
    //this指向debounce
    let context = this;
    //即参数，func,wait
    let args = arguments;

    //如果timer不为null, 清除定时器
    if (timer) clearTimeout(timer);

    //如果是立即执行
    if (immediate) {
      //定义callNow = !timer
      var callNow = !timer;
      //定义wait时间后把timer变为null
      //即在wait时间之后事件才会有效
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      //如果callNow为true,即原本timer为null
      //那么执行func函数
      if (callNow) func.apply(context, args);
    } else {
      //如果是不立即执行
      //那就是每次重新定时
      timer = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }
  };
}
/**
 * @desc 函数节流---“立即执行” 和 “非立即执行” 的组合版本
 * @param fn 需要执行的函数
 * @param wait 延迟执行时间（毫秒）
 * @param immediate---true 立即执行，false 非立即执行
 **/
export function throttle (fn, wait = 1500, isImmediate = true) {
  var flag = true;
  return function () {
    if (flag == true) {
      var context = this;
      var args = arguments;
      flag = false;
      isImmediate && fn.apply(context, args);
      setTimeout(() => {
        !isImmediate && fn.apply(context, args);
        flag = true;
      }, wait);
    }
  };
}



let ICON_FONT_IMG_MAP = {
  '9': 'panda_mobilerenliziyuan', // 人力资源
  '14': 'panda_mobilehetong3', // 合同
  '1': 'panda_mobilebangonglou1',// 企业设立
  '3': 'panda_mobileqiyeguanli', // 企业治理
  '19': 'panda_mobilezhishichanquan', // 知识产权
  '21': 'panda_mobileshuiwu', // 财税
  '29': 'panda_mobilezhiyao-', // 制药业
  '24': 'panda_mobilenongye', // 农业
  '26': 'panda_mobileanimal-husbandry', // 畜牧业
  '40': 'panda_mobileshangyezongheti1', // 商业综合体
  '38': 'panda_mobile-fuwu', // 汽车产业链
  '45': 'panda_mobiledianshang', // 电商零售
  '33': 'panda_mobilefangdichanjianzhu', // 房地产业
  '行政': 'panda_mobilehangzheng',
  '刑事': 'panda_mobileshoukao-copy',
  '劳动': 'panda_mobilelaodongli',
  '69': 'panda_mobilefangzhihangye', // 鞋服纺织
  '73': 'panda_mobiletaoci', // 陶瓷建材
  '67': 'panda_mobileshipin', // 食品加工
  '62': 'panda_mobilewuliu', // 交通物流
  '75': 'panda_mobileequipment', // 机械装备
  '81': 'panda_mobiledaikuanfuwu', // 集资、融资、贷款
  '82': 'panda_mobilexingshifanzui', // 职务犯罪
  '-99': 'panda_mobilelocking', // 锁
  '-1': 'panda_mobilebumen-moren' // 默认
}


let STATIC_IMG_MAP = {
  '9': 'people', // 人力资源
  '14': 'contract', // 合同
  '1': 'company', // 企业设立
  '3': 'governance', // 企业治理
  '19': 'wisdom', // 知识产权
  '21': 'tax', // 财税
  '29': 'medicine', // 制药业
  '24': 'agriculture', //'农业'
  '26': 'animal', // 畜牧业
  '40': 'complex', // 商业综合体
  '38': 'car', // 汽车产业链
  '45': 'online', // 电商零售
  '33': 'home', // 房地产业
  '69': 'clothes', // 鞋服纺织
  '73': 'ceramics', // 陶瓷建材
  '67': 'food', // 食品加工
  '62': 'traffic', // 交通物流
  '75': 'Mechanics', // 机械装备
  '81': 'jizuirongzi', // 集资、融资、贷款
  '82': 'zhiwufanzui', // 职务犯罪
  '-1': 'default', // 默认
}

export { ICON_FONT_IMG_MAP, STATIC_IMG_MAP }